import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {UtilsModule} from '../../utils/utils.module';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-supervisory-scheduler',
  templateUrl: './supervisory-scheduler.component.html',
  styleUrls: ['./supervisory-scheduler.component.css'],
  providers: [UtilsModule]
})
export class SupervisorySchedulerComponent implements OnInit {
  schedulerRadioValue = 'daily'; // 定时组件默认标签页
  schedulerDailyOccurrences = '1'; // 定时组件日默认值
  schedulerDailyTimeValue = new Date(); // 定时组件时间默认值
  schedulerDailyDate = '交易日'; //  定时组件日期默认值
  schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 个 ' + this.schedulerDailyDate + ' 的 ' +
    this.utilsModule.formatTimeByGeneral(this.schedulerDailyTimeValue); // 定时组件每日生成文本
  schedulerDateType = 'days';
  schedulerDateTypeText = '自然日';
  schedulerWeeklyOccurrences = '1'; // 定时组件周默认值
  schedulerWeeklyTimeValue = new Date(); // 定时组件时间默认值
  schedulerWeeklyDate = '交易日'; //  定时组件周日期默认值
  schedulerWeeklyDisplayText = '';
  schedulerWeeklyMergeText = '';
  schedulerWeeklyList: Array<any> = [];
  schedulerWeeklyArray: Array<any> = [];
  schedulerMonthlyOccurrences = '1'; // 定时组件月默认值
  schedulerMonthlyTimeValue = new Date(); // 定时组件时间默认值
  schedulerMonthlyDate = '交易日'; //  定时组件月日期默认值
  schedulerMonthlyDisplayText = '';
  schedulerMonthlyMergeText = '';
  schedulerMonthlyList: Array<any> = [];
  schedulerMonthlyArray: Array<any> = [];

  dateTypes = [
    {label: '自然日', value: 'days'},
    {label: '工作日', value: 'workdays'}
  ];
  // 时间区间配置
  hourStart = new Date();
  hourEnd = new Date();
  minutesHourStart = '';
  minutesHourEnd = '';
  minutesOccurrences = '1';
  minutesDateType = 'days';
  minutesInterval = '1';
  minutesDescription = '';
  @Input('nfData') set ChangeData(data: any) {
    if (data && JSON.stringify(data) !== '{}') {
      this.schedulerRadioValue = data.type;
      this.schedulerDateType = data.dateType;
      this.schedulerDateTypeChange();
      if (this.schedulerRadioValue === 'daily') {
        this.schedulerDailyOccurrences = data.occurrences;
        this.schedulerDailyTimeValue = new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + data.time);
        this.schedulerDailyDate = data.dateType === 'natural_day' ? '自然日' : '交易日';
        this.schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 个 ' + this.schedulerDailyDate + ' 的 ' + data.time;
      } else if (this.schedulerRadioValue === 'weekly') {
        setTimeout(() => {
          if (data.days && data.days.length) {
            this.schedulerWeeklyList.forEach((item, index) => {
              this.schedulerWeeklyList[index].select = false;
              for (let i = 0; i < data.days.length; i++) {
                if (data.days[i] === item.id) {
                  this.schedulerWeeklyList[index].select = true;
                }
              }
            });
          }
          this.schedulerWeeklyMerge();
        }, 200);
        this.schedulerWeeklyOccurrences = data.occurrences;
        this.schedulerWeeklyDate = data.dateType === 'natural_day' ? '自然日' : '交易日';
        this.schedulerWeeklyTimeValue = new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + data.time);
      } else if (this.schedulerRadioValue === 'monthly') {
        setTimeout(() => {
          if (data.days && data.days.length) {
            this.schedulerMonthlyList.forEach((item, index) => {
              this.schedulerMonthlyList[index].select = false;
              for (let i = 0; i < data.days.length; i++) {
                if (data.days[i] === item.id) {
                  this.schedulerMonthlyList[index].select = true;
                }
              }
            });
          }
          this.schedulerMonthlyMerge();
        }, 200);
        this.schedulerMonthlyOccurrences = data.occurrences;
        this.schedulerMonthlyDate = data.dateType === 'natural_day' ? '自然日' : '交易日';
        this.schedulerMonthlyTimeValue = new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + data.time);
      }
    } else if (this.schedulerRadioValue === 'minutes') {
      this.minutesOccurrences = data.occurrences;
      if (data.hourStart) {
        this.hourStart.setHours(Number(data.hourStart));
      }
      if (data.hourEnd) {
        this.hourEnd.setHours(Number(data.hourEnd));
      }
      this.minutesInterval = data.minutesInterval;
      this.minutesChange();
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private utilsModule: UtilsModule,
    private message: NzMessageService,
  ) { }

  ngOnInit(): void {
    // 定时初始化
    this.schedulerInit();
    if (this.schedulerRadioValue === 'weekly') {
      this.schedulerWeeklyMerge();
    }
    if (this.schedulerRadioValue === 'monthly') {
      this.schedulerMonthlyMerge();
    }
    if (this.schedulerRadioValue === 'minutes') {
      this.minutesChange();
    }
  }

  // 定时任务组件 - 初始化列表数据
  schedulerInit() {
    for (let i = 1; i < 8; i++) {
      let txt = '';
      switch (i) {
        case 1:
          txt = '周一';
          break;
        case 2:
          txt = '周二';
          break;
        case 3:
          txt = '周三';
          break;
        case 4:
          txt = '周四';
          break;
        case 5:
          txt = '周五';
          break;
        case 6:
          txt = '周六';
          break;
        case 7:
          txt = '周日';
          break;
      }
      const obj = {
        'id': i,
        'label': txt,
        'select': false
      };
      this.schedulerWeeklyList.push(obj);
    }
    for (let i = 1; i < 32; i++) {
      const obj = {
        'id': i,
        'label': i,
        'select': false
      };
      this.schedulerMonthlyList.push(obj);
    }
  }
  // 定时任务组件-radio切换
  schedulerRadioChange(event) {
    if (this.schedulerRadioValue === 'weekly') {
      this.schedulerWeeklyMerge();
    }
    if (this.schedulerRadioValue === 'monthly') {
      this.schedulerMonthlyMerge();
    }
    if (this.schedulerRadioValue === 'minutes') {
      this.minutesChange();
    }
  }
  // 定时任务组件-每日选择回调
  schedulerDailyTimeChange(event) {
    this.schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 个 ' + this.schedulerDailyDate + ' 的 ' + this.utilsModule.formatTimeByGeneral(event);
  }
  // 定时任务组件-每日间隔选择回调
  schedulerDailyOccurrencesChange(event) {
    this.schedulerDailyDisplayText = '每 ' + event + ' 个 ' + this.schedulerDailyDate + ' 的 '  + this.utilsModule.formatTimeByGeneral(this.schedulerDailyTimeValue);
  }
  // 定时任务组件- 自然日，交易日选择回掉
  schedulerDailyDateChange(event) {
    this.schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 个 ' + event + ' 的 '  + this.utilsModule.formatTimeByGeneral(this.schedulerDailyTimeValue);
  }
  // 定时任务组件-每周选择回调
  schedulerWeeklyTextChange(event) {
    event.select = !event.select;
    this.schedulerWeeklyMerge();
  }
  // 定时任务组件-每周选择回调
  schedulerWeeklyOccurrencesChange(event) {
    if (this.schedulerWeeklyMergeText) {
      this.schedulerWeeklyDisplayText = '每 ' + event + ' 周 属于 ' + this.schedulerWeeklyDate + ' 的 ' +
        this.schedulerWeeklyMergeText + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.schedulerWeeklyTimeValue);
    } else {
      this.schedulerWeeklyDisplayText = '每 ' + event + ' 周 属于 ' + this.schedulerWeeklyDate + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.schedulerWeeklyTimeValue);
    }
  }
  // 定时任务组件-每周选择回调
  schedulerWeeklyTimeChange(event) {
    if (this.schedulerWeeklyMergeText) {
      this.schedulerWeeklyDisplayText = '每 ' + this.schedulerWeeklyOccurrences + ' 周 属于 ' + this.schedulerWeeklyDate + ' 的 ' +
        this.schedulerWeeklyMergeText + ' 的 ' + this.utilsModule.formatTimeByGeneral(event);
    } else {
      this.schedulerWeeklyDisplayText = '每 ' + this.schedulerWeeklyOccurrences + ' 周 属于 ' + this.schedulerWeeklyDate + ' 的 ' + this.utilsModule.formatTimeByGeneral(event);
    }
  }
  // 定时任务组件-每周自然日，交易日选择回调
  schedulerWeeklyDateChange(event) {
    if (this.schedulerWeeklyMergeText) {
      this.schedulerWeeklyDisplayText = '每 ' + this.schedulerWeeklyOccurrences + ' 周 属于 ' + event + ' 的 ' +
        this.schedulerWeeklyMergeText + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.schedulerWeeklyTimeValue);
    } else {
      this.schedulerWeeklyDisplayText = '每 ' + this.schedulerWeeklyOccurrences + ' 周 属于 ' + event + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.schedulerWeeklyTimeValue);
    }
  }

  // 选中的周文字合并
  schedulerWeeklyMerge() {
    this.schedulerWeeklyArray = [];
    this.schedulerWeeklyList.forEach((item, index) => {
      if (item.select) {
        this.schedulerWeeklyArray.push(item.id);
      }
    });
    if (this.schedulerWeeklyArray.length > 0) {
      const weeklyText = [];
      this.schedulerWeeklyArray = Array.from(new Set(this.schedulerWeeklyArray));
      this.schedulerWeeklyArray = (this.schedulerWeeklyArray.sort((a, b) => {
        return a - b;
      }));
      for (let i = 0; i < this.schedulerWeeklyArray.length; i++) {
        switch (this.schedulerWeeklyArray[i]) {
          case 1:
            weeklyText.push('周一');
            break;
          case 2:
            weeklyText.push('周二');
            break;
          case 3:
            weeklyText.push('周三');
            break;
          case 4:
            weeklyText.push('周四');
            break;
          case 5:
            weeklyText.push('周五');
            break;
          case 6:
            weeklyText.push('周六');
            break;
          case 7:
            weeklyText.push('周日');
            break;
        }
      }
      this.schedulerWeeklyMergeText = weeklyText.join('，');
    } else {
      this.schedulerWeeklyMergeText = null;
    }
    if (this.schedulerWeeklyMergeText) {
      this.schedulerWeeklyDisplayText = '每 ' + this.schedulerWeeklyOccurrences + ' 周 属于 ' + this.schedulerWeeklyDate + ' 的 ' +
        this.schedulerWeeklyMergeText + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.schedulerWeeklyTimeValue);
    } else {
      this.schedulerWeeklyDisplayText = '每 ' + this.schedulerWeeklyOccurrences + ' 周 属于 ' + this.schedulerWeeklyDate + ' 的 ' +
        this.utilsModule.formatTimeByGeneral(this.schedulerWeeklyTimeValue);
    }
  }
  schedulerMonthlyTextChange(event) {
    event.select = !event.select;
    this.schedulerMonthlyMerge();
  }
  // 定时任务组件-每月选择间隔回调
  schedulerMonthlyOccurrencesChange(event) {
    if (this.schedulerMonthlyMergeText) {
      this.schedulerMonthlyDisplayText = '每 ' + event + ' 月 属于 ' + this.schedulerMonthlyDate + ' 的 '  + this.schedulerMonthlyMergeText + ' 号的 '
        + this.utilsModule.formatTimeByGeneral(this.schedulerMonthlyTimeValue);
    } else {
      this.schedulerMonthlyDisplayText = '每 ' + event + ' 月 属于 ' + this.schedulerMonthlyDate + ' 的 ' + this.utilsModule.formatTimeByGeneral(this.schedulerMonthlyTimeValue);
    }
  }
  // 定时任务组件-每月选择时间回调
  schedulerMonthlyTimeChange(event) {
    if (this.schedulerMonthlyMergeText) {
      this.schedulerMonthlyDisplayText = '每 ' + this.schedulerMonthlyOccurrences + ' 月 属于 ' + this.schedulerMonthlyDate + ' 的 ' +
        this.schedulerMonthlyMergeText + ' 号的' + this.utilsModule.formatTimeByGeneral(event);
    } else {
      this.schedulerMonthlyDisplayText = '每 ' + this.schedulerMonthlyOccurrences + ' 月 属于 ' + this.schedulerMonthlyDate + ' 的 ' +
        this.utilsModule.formatTimeByGeneral(event);
    }
  }
  // 选中的月文字合并
  schedulerMonthlyMerge() {
    this.schedulerMonthlyArray = [];
    this.schedulerMonthlyList.forEach((item, index) => {
      if (item.select) {
        this.schedulerMonthlyArray.push(item.id);
      }
    });
    if (this.schedulerMonthlyArray.length > 0) {
      this.schedulerMonthlyArray = Array.from(new Set(this.schedulerMonthlyArray));
      this.schedulerMonthlyArray = (this.schedulerMonthlyArray.sort((a, b) => {
        return a - b;
      }));
      this.schedulerMonthlyMergeText = this.schedulerMonthlyArray.join('号，');
    } else {
      this.schedulerMonthlyMergeText = null;
    }
    if (this.schedulerMonthlyMergeText) {
      this.schedulerMonthlyDisplayText = '每 ' + this.schedulerMonthlyOccurrences + ' 月 属于 ' + this.schedulerMonthlyDate + ' 的 ' +
        this.schedulerMonthlyMergeText + ' 号的 ' + this.utilsModule.formatTimeByGeneral(this.schedulerMonthlyTimeValue);
    } else {
      this.schedulerMonthlyDisplayText = '每 ' + this.schedulerMonthlyOccurrences + ' 月 属于 ' + this.schedulerMonthlyDate + ' 的 ' +
        this.utilsModule.formatTimeByGeneral(this.schedulerMonthlyTimeValue);
    }
  }

  // 定时任务组件-每月交易日，自然日回调
  schedulerMonthlyDateChange(event) {
    if (this.schedulerMonthlyMergeText) {
      this.schedulerMonthlyDisplayText = '每 ' + this.schedulerMonthlyOccurrences + ' 月 属于 ' + event + ' 的 ' +
        this.schedulerMonthlyMergeText + ' 号，' + this.utilsModule.formatTimeByGeneral(this.schedulerMonthlyTimeValue);
    } else {
      this.schedulerMonthlyDisplayText = '每 ' + this.schedulerMonthlyOccurrences + ' 月 属于 ' + event + ' 的 ' +
      this.utilsModule.formatTimeByGeneral(this.schedulerMonthlyTimeValue);
    }
  }
  // 提交定时
  schedulerOnSubmit() {
    let schedulerConfig = {};
    let schedulerConfigText = '';
    if (this.schedulerRadioValue === 'daily') {
      schedulerConfig = {
        'type': 'daily',
        'occurrences': this.schedulerDailyOccurrences,
        'dateType': this.schedulerDailyDate === '交易日' ? 'workday' : 'natural_day',
        'time': this.schedulerDailyTimeValue.getHours() + ':' +
          this.schedulerDailyTimeValue.getMinutes() + ':' + this.schedulerDailyTimeValue.getSeconds()
      };
      schedulerConfigText = this.schedulerDailyDisplayText;
    } else if (this.schedulerRadioValue === 'weekly') {
      if (!this.schedulerWeeklyArray || !this.schedulerWeeklyArray.length) {
        this.message.create('warning', '请选择每周的至少一天！');
        return
      }
      schedulerConfig = {
        'type': 'weekly',
        'occurrences': this.schedulerWeeklyOccurrences,
        'days': this.schedulerWeeklyArray,
        'dateType': this.schedulerWeeklyDate === '交易日' ? 'workday' : 'natural_day',
        'time': this.schedulerWeeklyTimeValue.getHours() + ':' +
          this.schedulerWeeklyTimeValue.getMinutes() + ':' + this.schedulerWeeklyTimeValue.getSeconds()
      };
      schedulerConfigText = this.schedulerWeeklyDisplayText;
    } else if (this.schedulerRadioValue === 'monthly') {
      if (!this.schedulerMonthlyArray || !this.schedulerMonthlyArray.length) {
        this.message.create('warning', '请选择每月的至少一天！');
        return
      }
      schedulerConfig = {
        'type': 'monthly',
        'occurrences': this.schedulerMonthlyOccurrences,
        'days': this.schedulerMonthlyArray,
        'dateType': this.schedulerMonthlyDate === '交易日' ? 'workday' : 'natural_day',
        'time': this.schedulerMonthlyTimeValue.getHours() + ':' +
          this.schedulerMonthlyTimeValue.getMinutes() + ':' + this.schedulerMonthlyTimeValue.getSeconds()
      };
      schedulerConfigText = this.schedulerMonthlyDisplayText;
    } else if (this.schedulerRadioValue === 'minutes') {
      this.minutesHourStart = this.formatHoursByGeneral(this.hourStart);
      this.minutesHourEnd = this.formatHoursByGeneral(this.hourEnd);
      schedulerConfig = {
        'type': 'minutes',
        'occurrences': this.minutesOccurrences,
        'hourStart': this.minutesHourStart,
        'hourEnd': this.minutesHourEnd,
        'minutesInterval': this.minutesInterval
      };
      schedulerConfigText = this.minutesDescription = '每' + this.minutesOccurrences + ' 个 ' + this.getSelectTitle(this.dateTypes, this.minutesDateType) + ' 的 ' + this.formatHoursByGeneral(this.hourStart) + '时至' + this.formatHoursByGeneral(this.hourEnd) + '时 每隔' + this.minutesInterval + '分钟';
    }
    schedulerConfig['dateType'] = this.schedulerDateType;
    const schedulerConfigData = {
      'config': schedulerConfig,
      'text': schedulerConfigText
    };
    this.nfDataChange.emit(schedulerConfigData);
  }

  // 日期类型选择回调
  schedulerDateTypeChange() {
    for (const dateType of this.dateTypes) {
      if (dateType.value === this.schedulerDateType) {
        this.schedulerDateTypeText = dateType.label;
        break;
      }
    }
  }

  // 处理时间区间
  minutesChange() {
    this.minutesDescription = '每' + this.minutesOccurrences + ' 个 ' + this.getSelectTitle(this.dateTypes, this.schedulerDateType) + ' 的 ' + this.formatHoursByGeneral(this.hourStart) + '时至' + this.formatHoursByGeneral(this.hourEnd) + '时 每隔' + this.minutesInterval + '分钟';
  }

  // 获取下拉选项的表述
  getSelectTitle(target: Array<any>, value): string {
    if (target && target.length > 0) {
      for (let item of target) {
        if (item.value === value) {
          return item.label;
        }
      }
      return '';
    } else {
      return '';
    }
  }

  // 格式化时间格式返回HH
  formatHoursByGeneral(date) {
    if (date) {
      let hours = date.getHours();
      if (hours >= 0 && hours <= 9) {
        hours = '0' + hours;
      }
      return hours;
    }
  }
}
